import styled from 'styled-components';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 200px;
    overflow: scroll;
    padding: 10px;
`;